import { IAutoStoreControlAppState, ActionStates, IAutoStoreBoxReview, IAutoStoreFetchBoxReviewRequest, IAutoStoreRestartBoxDeliveryRequest } from "../../../components/AutoStoreControlApp/IAutoStoreControlAppState";
import AFrameReviewBox from "../../aframeboxlookup/AFrameReviewBox";
import { ISortBoxItemModel } from "../../SortBoxItem/ISortBoxItemModel";
import { IPayloadWrapper } from "../types/PayloadWrapper";
/**
 * -------------------------------------
 * Action Types definition
 * -------------------------------------
 * */
export const SET_ACTION = "automatpacken/autostoreAppMode/SET_ACTION";
export const TOGGLE_SCAN = "automatpacken/autostoreAppMode/TOGGLE_SCAN";
export const TOGGLE_VERIFY_IPACKBOX_BARCODE_MODAL =
  "automatpacken/autostoreAppMode/TOGGLE_VERIFY_IPACKBOX_BARCODE_MODAL";
export const CLEAR_APP_STATE = "automatpacken/autostoreAppMode/CLEAR_APP_STATE";
export const FETCH_REVIEW_BOX = "automatpacken/autostoreAppMode/FETCH_REVIEW_BOX";
export const SET_REVIEW_BOX = "automatpacken/autostoreAppMode/SET_REVIEW_BOX";
export const SET_MISSING_SORTBOX_ITEM = "automatpacken/autostoreAppMode/SET_MISSING_SORTBOX_ITEM";
export const SET_SHOW_MISSING_AMOUNT_DIALOG_SORTBOX_ITEM = "automatpacken/autostoreAppMode/SET_SHOW_MISSING_AMOUNT_DIALOG_SORTBOX_ITEM";
export const SET_WARNING_MESSAGE = "automatpacken/autostoreAppMode/SET_WARNING_MESSAGE";
export const CLEAR_WARNING_MESSAGE = "automatpacken/autostoreAppMode/CLEAR_WARNING_MESSAGE";
export const SET_IPACKBOX_BARCODE = "automatpacken/autostoreAppMode/SET_IPACKBOX_BARCODE";
export const SET_SHOW_VERIFY_IPACKBOX_MODAL = "automatpacken/autostoreAppMode/SET_SHOW_VERIFY_IPACKBOX_MODAL";
export const SET_PUT_BACK_EMPTY_BOX = "automatpacken/autostoreAppMode/SET_PUT_BACK_EMPTY_BOX";
export const SET_WEIGHT_ERROR = "automatpacken/autostoreAppMode/SET_WEIGHT_ERROR";
export const SET_RESTART_DELIVERY_MODAL_OPEN = "automatpacken/autostoreAppMode/SET_RESTART_DELIVERY_MODAL_OPEN";
export const RESTART_BOX_DELIVERY = "automatpacken/autostoreAppMode/RESTART_BOX_DELIVERY";
export const SET_WRONG_RX_BAG_SCANNED = "automatpacken/autostoreAppMode/SET_WRONG_RX_BAG_SCANNED";
export const SET_BOX_REPLACEMENT_NEEDED = "automatpacken/autostoreAppMode/SET_BOX_REPLACEMENT_NEEDED";
export const SET_BOX_REPLACEMENT_ERROR = "automatpacken/autostoreAppMode/SET_BOX_REPLACEMENT_ERROR";

export const setBoxReplacementNeeded = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_BOX_REPLACEMENT_NEEDED,
    payload
  }
}


export const setBoxReplacementError = (payload: IPayloadWrapper<string | null>) => {
  return {
    type: SET_BOX_REPLACEMENT_ERROR,
    payload
  }
}

export const setWeightError = (payload: IPayloadWrapper<string>) => {
  return {
    type: SET_WEIGHT_ERROR,
    payload
  }
}


export const setTransitBoxEmpty = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_PUT_BACK_EMPTY_BOX,
    payload
  }
}


export const setShowVerifyIpackBoxModal = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_SHOW_VERIFY_IPACKBOX_MODAL,
    payload
  }
}


export const setIPackBoxBarcode = (payload: IPayloadWrapper<string>) => {
  return {
    type: SET_IPACKBOX_BARCODE,
    payload
  }
}

export const clearWarningMessage = () => {
  return {
    type: CLEAR_WARNING_MESSAGE
  }
}


export const setWarningMessage = (payload: IPayloadWrapper<string>) => {
  return {
    type: SET_WARNING_MESSAGE,
    payload
  }
}


export const setWrongRxBagScanned = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_WRONG_RX_BAG_SCANNED,
    payload
  }
}


export const setShowMissingAmountDialogSortBoxItem = (payload: IPayloadWrapper<ISortBoxItemModel | null>) => {
  return {
    type: SET_SHOW_MISSING_AMOUNT_DIALOG_SORTBOX_ITEM,
    payload
  }
}


export const setMissingSortBoxItem = (payload: IPayloadWrapper<ISortBoxItemModel | null>) => {
  return {
    type: SET_MISSING_SORTBOX_ITEM,
    payload
  }
}

export const setRestartDeliveryModalOpen = (action: IPayloadWrapper<boolean>) => {
  return {
    type: SET_RESTART_DELIVERY_MODAL_OPEN,
    payload: action,
  };
};

export const setReviewBox = (action: IPayloadWrapper<IAutoStoreBoxReview>) => {
  return {
    type: SET_REVIEW_BOX,
    payload: action,
  };
};

export const setAction = (action: IPayloadWrapper<ActionStates>) => {
  return {
    type: SET_ACTION,
    payload: action,
  };
};

export const toggleScan = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: TOGGLE_SCAN,
    payload,
  };
};

export const toggleverifyIPackBoxBarcodeModal = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: TOGGLE_VERIFY_IPACKBOX_BARCODE_MODAL,
    payload,
  };
};

export const clearState = () => {
  return {
    type: CLEAR_APP_STATE,
  }
}

export const fetchReviewBox = (payload: IPayloadWrapper<IAutoStoreFetchBoxReviewRequest>) => {
  return {
    type: FETCH_REVIEW_BOX,
    payload,
  };
};

export const restartBoxDelivery = (payload: IPayloadWrapper<IAutoStoreRestartBoxDeliveryRequest>) => {
  return {
    type: RESTART_BOX_DELIVERY,
    payload,
  };
};


const initialAutoStoreControlAppState: IAutoStoreControlAppState = {
  action: ActionStates.LOAD_BOX,
  scanDisabled: false,
  boxReview: null,
  missingSortBoxItem: null,
  showMissingAmountDialogSortBoxItem: null,
  warningMessage: null,
  showVerifyIPackBoxBarcodeModal: false,
  iPackBoxBarcode: null,
  isEmptyTransitBox: false,
  weightError: '',
  restartDeliveryModalOpen: false,
  wrongRXBagScanned: false,
  boxReplacementNeeded: false,
  boxReplacementError: null
};



/**
 * -------------------------------------
 * Reducer definition
 * -------------------------------------
 * */
const autostoreModeReducer = (state = initialAutoStoreControlAppState, action: any) => {
  switch (action.type) {
    case SET_ACTION:
      return {
        ...state,
        action: action.payload.value,
      };
    case SET_BOX_REPLACEMENT_ERROR:{
      return { ...state, boxReplacementError: action.payload.value }; 
    }
    case SET_BOX_REPLACEMENT_NEEDED:
      return { ...state, boxReplacementNeeded: action.payload.value }; 
    case TOGGLE_SCAN:
      return { ...state, scanDisabled: action.payload.value };
    case TOGGLE_VERIFY_IPACKBOX_BARCODE_MODAL:
      return { ...state, verifyIPackBoxBarcodeModalOpen: action.payload.value };
    case CLEAR_APP_STATE:
      return { ...state, ...initialAutoStoreControlAppState };
    case SET_REVIEW_BOX:
      return { ...state, boxReview: action.payload.value };
    case SET_MISSING_SORTBOX_ITEM: {
      return { ...state, missingSortBoxItem: action.payload.value }
    }
    case SET_SHOW_MISSING_AMOUNT_DIALOG_SORTBOX_ITEM: {
      return { ...state, showMissingAmountDialogSortBoxItem: action.payload.value }
    }
    case SET_WARNING_MESSAGE: {
      return { ...state, warningMessage: action.payload.value }
    }
    case CLEAR_WARNING_MESSAGE: {
      return { ...state, warningMessage: null }
    }
    case SET_IPACKBOX_BARCODE: {
      return { ...state, iPackBoxBarcode: action.payload.value }
    }
    case SET_SHOW_VERIFY_IPACKBOX_MODAL: {
      return { ...state, showVerifyIPackBoxBarcodeModal: action.payload.value }
    }
    case SET_PUT_BACK_EMPTY_BOX: {
      return { ...state, isEmptyTransitBox: action.payload.value }
    }
    case SET_WEIGHT_ERROR:{
        return { ...state, weightError: action.payload.value }
    }
    case SET_RESTART_DELIVERY_MODAL_OPEN: {
      return { ...state, restartDeliveryModalOpen: action.payload.value }
    }
    case SET_WRONG_RX_BAG_SCANNED:{
      return { ...state, wrongRXBagScanned: action.payload.value }
    }
    default:
      return state;
  }
};

/**
 * -------------------------------------
 * Public interface
 * -------------------------------------
 * */
export default autostoreModeReducer;
